import React, { useState } from 'react';

function LoginForm(props) {
    const [email, setEmail] = useState('email');
    const [password, setPassword] = useState('password');
    return (
        <div>
            <div className="form-group">
                <label for="exampleInputEmail1">Email address</label>
                <input
                    type="email"
                    className="form-control"
                    id="exampleInputEmail1"
                    placeholder="Enter email"
                    onChange={(e) => setEmail(e.target.value)}
                />
            </div>
            <div className="form-group">
                <label for="exampleInputPassword1">Password</label>
                <input
                    type="password"
                    className="form-control"
                    id="exampleInputPassword1"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                />
            </div>
            <button
                onClick={() => props.onClick(email, password)}
                className="btn btn-primary"
            >
                Submit
            </button>
        </div>
    )
}

export default LoginForm;